import { DataBean } from "../DataBean";

export class RawMaterialSupplier extends DataBean {

    public async getRawMaterialSupplierCatalog(idRawMaterial: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getRawMaterialSupplierCatalog_Number", [idRawMaterial]);
    }

}
